// Framework
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// Services
import { AuthService } from './auth.service';
import { DataService } from './data.service';

@Injectable()

export class AuthGuard {
    constructor (
        private authSvc: AuthService,
        private router: Router,
        private dataSvc: DataService
    ) { }

    canActivate(): Observable<boolean> {
        return this.authSvc.$authState
        .pipe(
            map((auth) => {
                if (!!auth) { // Logged in, redirect to signup auth
                    // this.router.navigate(['/sign-up-auth'], { queryParamsHandling: 'preserve' });
                    // this.dataSvc.setUID(auth.uid);
                    return true;
                }
                else {
                    this.router.navigate(['/error404'])
                    return false;
                }
            })
        );
    }
}